<template>
    <div>
        <section class="all-quizes">
            <div class="container-fluid" style="max-width:1440px;">
                <div class="row">
                    <div class="col-md-3 pos-stick">
                        <div class="filters-side filters-bar set-height-s nd-shadow">
                            <div class="flex-filter">
                                <h3 class="filters-heading"><i class="fa fa-filter"></i> Filters</h3>
                                <div class="clear-filter" @click="clearFilers()">Clear Filters</div>
                            </div>
                            <!--                            <div class="sort-by-filter">-->
                            <!--                                <h3 class="side-top-heading">Sort By</h3>-->
                            <!--                                <select id="sorting-by" class="form-select-filter">-->
                            <!--                                    <option>Prizes</option>-->
                            <!--                                    <option>Days Left</option>-->
                            <!--                                </select>-->
                            <!--                            </div>-->
                            <div class="quiz-status-filter">
                                <h3 class="side-top-heading">Status</h3>
                                <div class="switch-field">
                                    <input type="radio" id="all" v-model="status" name="status" value="All" @change="filterList()">
                                    <label for="all">All</label>
                                    <input type="radio" id="live" v-model="status" name="status" value="live" @change="filterList()">
                                    <label for="live">Live</label>
                                    <input type="radio" id="expired" v-model="status" name="status" value="expired" @change="filterList()">
                                    <label for="expired">Expired</label>
                                </div>
                            </div>
                            <div class="payment-mode-filter">
                                <h3 class="side-top-heading">Payment</h3>
                                <div class="switch-field">
                                    <input type="radio" id="all-pay" v-model="payment" value="All" @change="filterList()"
                                           checked="">
                                    <label for="all-pay">All</label>
                                    <input type="radio" id="paid" v-model="payment" value="paid" @change="filterList()">
                                    <label for="paid">Paid</label>
                                    <input type="radio" id="free" v-model="payment" value="free" @change="filterList()">
                                    <label for="free">Free</label>
                                </div>
                            </div>
                            <div class="top-cat-filter" v-if="categoriesList.length">
                                <h3 class="side-top-heading">Category</h3>
<!--                                <input type="text" class="form-control category-input" onkeyup="searchCategory(event)"-->
<!--                                       placeholder="Search Category">-->
                                <ul class="eligibility-category">
                                    <li v-for="ct in categoriesList">
                                        <input :id="ct.category_enc_id" type="checkbox" name="categoryFilter" @change="filterList()" value="category" class="check-custom">
                                        <label :for="ct.category_enc_id" class="check-custom-label">{{ ct.name }}</label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-9">
                        <div class="row" id="quizDiv" v-if="companies.length">
                            <div class="col-md-6" v-for="data in companies">
                                <router-link :to="{path: '/quiz/' + data.slug}">
                                    <div class="card-main nd-shadow">
                                        <div class="paid-webinar" v-if="data.is_paid == '1'">Paid</div>
                                        <div class="expired-btn" v-if="data.is_expired == 'true'">EXPIRED</div>
                                        <div class="card-img">
                                            <img :src="data.banner_sharing_image ? data.banner_sharing_image : '/images/quiz-default.png'"/>
                                        </div>
                                        <div class="card-details">
                                            <div class="about-first flex-container">
                                                <div class="register-date" style="flex-grow: 1"><i
                                                    class="far fa-user"></i> {{ data.registered_count }} Registered
                                                </div>
                                                <div class="pricing-money" style="flex-grow: 8" v-if="data.quizRewards.length">
                                                    <img src="https://shshank.eygb.me/assets/themes/ey/images/pages/quiz/PRIZE.png">
                                                    ₹{{ data.quizRewards[0].price }}
                                                </div>
                                            </div>
                                            <div class="about-name">
                                                <div class="quiz-name">{{ data.name }}</div>
                                                <div class="quiz-category">{{data.category}}</div>
                                            </div>
                                            <div class="about-footer">
                                                <div class="views-count">
<!--                                                    <i class="fa fa-eye"></i> 6 Views-->
                                                </div>

                                                <div class="register-date" v-if="data.price">
                                                    <i class="fas fa-rupee-sign"></i>{{ data.price }}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                        <div class="row" id="quizDiv" v-else>
                            <div id="not-found" class="col-md-12 text-center hidden">
                                <img src="images/dashboard/no_data_found.png" class="no-data-found"/>
                                <h2 class="no-data-found">No Quizzes Found</h2>
                            </div>
                        </div>
                        <div class="col-md-12 text-center">
                            <div id="loading-list">
                                <div class="loading-list fixed"></div>
                                <div class="loading-list-ring fixed"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import axios from 'axios'
import toastr from "../../public/js/toastr";
import messageModal from "@/components/messageModal";
import educationLoanWebinar from "@/components/educationLoanWebinar";
import webinarWidget from "@/components/webinarWidget";
import {hideLoader, requestHeaders, showLoader} from "../_helpers/apiHelper";

export default {
    components: {},
    data() {
        return {
            data: '',
            status: 'live',
            payment: 'All',
            category: [],
            companies: [],
            categoriesList: [],
            request: false,
            bottom: false,
            loadMore: true,
            page: 1,
        }
    },
    mounted() {
        $('.filters-side').perfectScrollbar();
        this.getCategoriesList();
        this.getCompanies();
    },
    methods: {
        shortlist: function (event) {
            var t = this;
            var element = event.currentTarget
            var data_key = element.getAttribute('data-key');
            var url = this.$store.getters.getDomain;
            var slug = this.$route.query.id;
            axios.post(`${url}api/v2/jobs/shortlist-application`, {application_enc_id: data_key}, {
                headers: requestHeaders()
            })
                .then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        t.isshortlisted = true;
                    } else {
                        t.isshortlisted = false;
                    }
                })
        },
        bottomVisible() {
            const scrollY = window.scrollY
            const visible = document.documentElement.clientHeight
            const pageHeight = document.documentElement.scrollHeight;

            const bottomOfPage = visible + scrollY >= pageHeight - 200;
            return bottomOfPage;
        },
        addList() {
            if (this.request) {
                this.loadMore = false;
                var url = this.$store.getters.getDomain;

                var a = this;

                var bodyFormData = new FormData();
                bodyFormData.set('page', a.page);
                // bodyFormData.set('sort_by', a.sortBy);
                bodyFormData.set('limit', 20);
                bodyFormData.set('status', a.status);
                bodyFormData.set('payment', a.payment);
                bodyFormData.set('category', a.category);

                axios({
                    method: 'POST',
                    url: `${url}api/v2/quiz/list`,
                    headers: requestHeaders(),
                    data: bodyFormData,
                }).then(function (response) {
                    if (response['data']['response']['data']) {
                        for (var i = 0; i < response['data']['response']['data'].length; i++) {
                            a.companies.push(response['data']['response']['data'][i])
                        }
                        if (a.bottomVisible()) {
                            a.page += 1;
                            a.addList()
                        }
                        setTimeout(function () {
                            // a.matchHeight();
                        }, 700)
                        // a.$store.dispatch("setCompanies", a.companies);
                        a.loadMore = true;
                    } else {
                        a.request = false;
                    }
                })
                    .catch(function (error) {
                        console.log(error)
                    })
            }
        },
        clearFilers(){
            var t = this
            t.status = 'All';
            t.payment = 'All';
            t.category = [];
            var el_category = document.getElementsByName('categoryFilter');
            for (var k = 0; k < el_category.length; k++) {
                el_category[k].checked = false;
            }
            this.getCompanies();
        },
        filterList() {
            // this.category = document.querySelector('input[name="categoryFilter"]:checked').value;
            // this.badge_filter = document.querySelector('select[name="badge-filter"]').value;
            var t = this;
            t.category = [];
            var el_category = document.getElementsByName('categoryFilter');
            for (var k = 0; k < el_category.length; k++) {
              if (el_category[k].checked) {
                  t.category.push(el_category[k].value);
              }
            }
            this.getCompanies();
        },
        getCompanies() {
            if (document.getElementById("loading-list")) {
                var fadeTarget = document.getElementById("loading-list");
                fadeTarget.style.display = "block";
            }

            var t = this;
            t.companies = [];
            var url = this.$store.getters.getDomain;

            axios.post(`${url}api/v2/quiz/list`, {
                limit: 20,
                page: 1,
                status: t.status,
                payment: t.payment,
                category: t.category
            }, {headers: requestHeaders()}).then(function (response) {
                if (response['data']['response']['status'] === 200) {
                    t.companies = response['data']['response']['data'];
                    // t.$store.dispatch("setCompanies", t.companies);
                    setTimeout(function () {
                        // t.matchHeight();
                    }, 500);
                    t.request = true;
                    t.page = 1;
                } else {
                    // if (t.badge_filter) {
                    //     document.querySelector('select[name="badge-filter"]').value = "";
                    //     alert('No companies Found');
                    // }
                    if (document.getElementById("not-found")) {
                        document.getElementById("not-found").classList.remove('hidden');
                    }
                }
                if (document.getElementById("loading-list")) {
                    var fadeTarget = document.getElementById("loading-list");
                    fadeTarget.style.display = "none";
                }
            });
        },
        getCategoriesList() {
            var t = this;
            var url = this.$store.getters.getDomain;

            axios.post(`${url}api/v2/quiz/categories`, {}, {headers: requestHeaders()}).then(function (response) {
                if (response['data']['response']['status'] === 200) {
                    t.categoriesList = response['data']['response']['categories'];
                } else {

                }
            });
        },
    },
    watch: {
        bottom(bottom) {
            if (bottom) {
                this.page += 1;
                this.addList()
            }
        }
    },
    created() {
        window.addEventListener('scroll', () => {
            this.bottom = this.bottomVisible()
        })
    }
}
</script>

<style scoped>
.flex-filter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
}

.clear-filter {
    background-color: #00a0e3;
    color: #fff;
    padding: 2px 10px;
    border-radius: 50px;
    line-height: 2;
    font-size: 12px;
    font-family: "Roboto";
    cursor: pointer;
}

html {
    scroll-behavior: smooth;
}

.eligibility-category li {
    list-style: none;
}

#quizDiv {
    padding-top: 100px;
    min-height: 110vh;
}

.pos-stick {
    position: sticky;
    top: 100px;
}

.set-height-s {
    height: 80vh;
    overflow: hidden;
    margin-bottom: 20px;
    padding: 20px 10px;
    border-radius: 4px;
    position: relative;
}

h3.filters-heading {
    font-size: 18px;
    font-family: "Roboto";
    font-weight: 500;
    margin: 0;
}

h3.side-top-heading {
    font-size: 16px;
    font-family: "Roboto";
    font-weight: 400;
}

.nd-shadow {
    box-shadow: 0px 1px 10px 2px #eee !important;
}

.filters-heading i {
    color: #00a0e3;
}

.form-select-filter {
    width: 100%;
    border: 2px solid #eee;
    padding: 6px;
    border-radius: 4px;
    font-family: "Roboto";
    background-color: #f6f6f6;
}

.switch-field {
    display: flex;
    overflow: hidden;
    border: 2px solid #eee;
    border-radius: 40px;
    justify-content: space-between;
}

.switch-field input {
    position: absolute !important;
    clip: rect(0, 0, 0, 0);
    height: 1px;
    width: 1px;
    border: 0;
    overflow: hidden;
}

.switch-field label {
    font-size: 14px;
    text-align: center;
    padding: 8px 16px;
    transition: all 0.1s ease-in-out;
    line-height: 1;
    font-family: "Roboto";
    margin: 2px;
    width: 33%;
    cursor: pointer;
}

.switch-field input:checked + label {
    background-color: #00a0e3;
    color: #fff;
    border-radius: 33px;
}

.slidecontainer {
    width: 100%; /* Width of the outside container */
}

/* The slider itself */
.slider {
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    height: 12px;
    background: #eee;
    outline: none;
    opacity: 0.7;
    -webkit-transition: .2s;
    transition: opacity .2s;
}

/* Mouse-over effects */
.slider:hover {
    opacity: 1; /* Fully shown on mouse-over */
}

/* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
.slider::-webkit-slider-thumb {
    -webkit-appearance: none; /* Override default look */
    appearance: none;
    width: 12px; /* Set a specific slider handle width */
    height: 18px; /* Slider handle height */
    background: #00a0e3;
    cursor: pointer; /* Cursor on hover */
}

.slider::-moz-range-thumb {
    width: 25px; /* Set a specific slider handle width */
    height: 25px; /* Slider handle height */
    background: #04AA6D; /* Green background */
    cursor: pointer; /* Cursor on hover */
}

.range-counter {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: "Roboto";
    margin: 6px 0px 0;
}

.category-input {
    height: 40px;
    margin-bottom: 10px;
    border-radius: 4px;
    font-family: "Roboto";
    border: 2px solid #eee;
}

.radio-custom, .check-custom {
    opacity: 0;
    position: absolute;
}

.radio-custom, .radio-custom-label, .check-custom, .check-custom-label {
    display: inline-block;
    vertical-align: middle;
    margin: 5px;
    cursor: pointer;
    font-family: "Roboto";
    font-size: 15px;
    text-transform: capitalize;
}

.radio-custom-label, .check-custom-label {
    position: relative;
}

.radio-custom + .radio-custom-label:before, .check-custom + .check-custom-label:before {
    content: "";
    background: #fff;
    border: 2px solid #ddd;
    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: 20px;
    padding: 2px;
    margin-right: 10px;
    text-align: center;
}

.radio-custom + .radio-custom-label:before {
    border-radius: 50%;
}

.radio-custom:checked + .radio-custom-label:before, .check-custom:checked + .check-custom-label:before {
    background: #00a0e3;
    box-shadow: inset 0px 0px 0px 2px #fff;
    border-color: #00a0e3
}

.radio-custom:checked + .radio-custom-label, .check-custom:checked + .check-custom-label {
    color: #00a0e3;
}

/* card css starts here */
.card-main {
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 30px;
    position: relative;
    min-height: 355px;
}

.paid-webinar {
    position: absolute;
    right: -25px;
    background-color: #f80000;
    color: #fff;
    font-family: "Roboto";
    font-weight: 700;
    padding: 0px 28px;
    transform: rotate(45deg);
    top: 14px;
    letter-spacing: 2px;
    text-transform: uppercase;
}

.card-img img {
    width: 100%;
    height: 240px;
    object-fit: fill;
    border-radius: 4px 0 0 0;
}

.card-details {
    padding: 10px;
    font-family: "Roboto";
}

.flex-container {
    display: flex;
    align-items: center;
    margin: 10px 0;
}

.days-left i, .register-date i {
    color: #00a0e3;
    font-size: 16px;
    margin-right: 2px;
}

.pricing-money {
    text-align: right;
    font-size: 16px;
    color: #e2bc0c;
}

.pricing-money i {
    font-size: 24px;
}

.quiz-name {
    font-size: 18px;
    font-family: "Roboto";
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.quiz-category {
    text-transform: capitalize;
    color: #b8b8b8;
    margin-bottom: 10px;
}

.about-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.view-details {
    background: linear-gradient(346deg, rgb(189 234 255) 0%, rgba(23, 148, 190, 1) 47%);
    color: #fff;
    padding: 4px 18px;
    display: inline-block;
    border-radius: 32px;
    margin-right: 5px;
}

.view-details:focus, .view-details:hover {
    color: #fff;
    transform: scale(1.05);
    transition: all .3s;
}

.expired-btn {
    padding: 0px 10px;
    background-color: #ff7803;
    position: absolute;
    top: 0;
    left: 0;
    color: #fff;
    font-family: "Roboto";
    font-weight: 500;
}

.views-count {
    color: #018e01;
}
.about-name{
    height:39px;
}
/* card css ends here */
</style>